<div [className]="themeClass" class="mat-app-background">
  <mat-sidenav-container>
    <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="isSidebarOpen">
      <mat-toolbar class="sidebar-top">
        <img class="sidebar-logo" src="assets/icons/icon-144x144.png" />
      </mat-toolbar>
      <mat-divider></mat-divider>
      <mat-nav-list>
        <a mat-list-item routerLink="/" [class.selected]="'/' === router?.url">
          <mat-icon>home</mat-icon>
          Home
        </a>
        <h3 matSubheader>Tools</h3>
        <a mat-list-item *ngFor="let item of navItems" routerLink="{{ item.path }}" [class.selected]="item.path === currentNavItem?.path">
          <mat-icon>{{ item.icon }}</mat-icon>
          {{ item.label }}
        </a>
        <h3 matSubheader>Bookmarks</h3>
        <a mat-list-item *ngFor="let item of bookmarks" href="{{ item.url }}" target="_blank">
          <img src="{{ item.icon }}" height="24" />
          {{ item.label }}
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="primary" class="main-toolbar">
        <button mat-icon-button aria-label="Menu" (click)="toggleSidebar()">
          <mat-icon>menu</mat-icon>
        </button>
        <h1>{{ currentNavItem?.label }}</h1>
        <span class="spacer"></span>
        <mat-select [(value)]="themeClass" (selectionChange)="onThemeChanged($event)">
          <mat-option *ngFor="let theme of availableThemes" [value]="theme.class">
            {{ theme.label }}
          </mat-option>
        </mat-select>
      </mat-toolbar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <button class="potted-plant" mat-fab color="accent" aria-label="My potted plant" (click)="plant()">
        <mat-icon>grass</mat-icon>
      </button>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
